<template>
  <section class="page home">
      <AppAnimatedTitle ref="animatedTitle" v-if="!isMobile"/>
      <div class="home__title" :class="{'not-loaded': notLoaded}">
        <AppTitle title="labor of fashion" size="little" :clickTitle="true" :translated="true"/>
      </div>

    <!-- Desktop grid container -->

    <div v-if="!isMobile" class="home__grid container">
        <div class="home__grid__products-text vertical-text">new products</div>
        <div class="home__grid__editorial-text vertical-text">editorial</div>
        <div class="home__grid__cols" :class="{'not-loaded': notLoaded}">
          <div class="home__grid__col">
            <template v-if="loadedContent">
              <div v-for="(item, index) in content.acf.first_column_items" :key="index" class="home__grid__elem">
                <AppParallaxeElem :amount="0.1">
                  <AppProductCard :invertScale="0.9" :content="item.item" v-if="item.item.post_type === 'products'"/>

                  <router-link :to="`/articles/${item.item.ID}`" class="home__grid__elem__container" v-else>
                    <AppLazyImg :alt="item.item.acf.preview_image.alt" :url="item.item.acf.preview_image.sizes.medium" :width="item.item.acf.preview_image.sizes['medium-width']" :height="item.item.acf.preview_image.sizes['medium-height']" :classes="['home__grid__elem__img']" />
                    <div class="home__grid__elem__overlay">
                      <div class="home__grid__elem__inner">
                        <p class="home__grid__elem__title" :style="{'transform': 'scale(0.9)'}" v-html="item.item.acf.displayed_title"></p>
                      </div>
                    </div>
                  </router-link>

                </AppParallaxeElem>
              </div>
            </template>
          </div>
          <div class="home__grid__col">

            <template v-if="loadedContent">
              <div v-for="(item, index) in content.acf.second_column_items" :key="index" class="home__grid__elem">
                <AppParallaxeElem :amount="0.1" :direction="1">
                  <AppProductCard :invertScale="0.9" :content="item.item" v-if="item.item.post_type === 'products'"/>

                  <router-link :to="`/articles/${item.item.ID}`" class="home__grid__elem__container" v-else>
                    <AppLazyImg :alt="item.item.acf.preview_image.alt" :url="item.item.acf.preview_image.sizes.medium" :width="item.item.acf.preview_image.sizes['medium-width']" :height="item.item.acf.preview_image.sizes['medium-height']" :classes="['home__grid__elem__img']" />
                    <div class="home__grid__elem__overlay">
                      <div class="home__grid__elem__inner">
                        <p class="home__grid__elem__title" :style="{'transform': 'scale(0.9)'}" v-html="item.item.acf.displayed_title"></p>
                      </div>
                    </div>
                  </router-link>

                </AppParallaxeElem>
              </div>
            </template>
          </div>
          <div class="home__grid__col">
            <template v-if="loadedContent">
              <div v-for="(item, index) in content.acf.third_column_items" :key="index" class="home__grid__elem">
                <AppParallaxeElem :amount="0.1">
                  <AppProductCard :invertScale="0.9" :content="item.item" v-if="item.item.post_type === 'products'"/>

                  <router-link :to="`/articles/${item.item.ID}`" class="home__grid__elem__container" v-else>
                    <AppLazyImg :alt="item.item.acf.preview_image.alt" :url="item.item.acf.preview_image.sizes.medium" :width="item.item.acf.preview_image.sizes['medium-width']" :height="item.item.acf.preview_image.sizes['medium-height']" :classes="['home__grid__elem__img']" />
                    <div class="home__grid__elem__overlay">
                      <div class="home__grid__elem__inner">
                        <p class="home__grid__elem__title" :style="{'transform': 'scale(0.9)'}" v-html="item.item.acf.displayed_title"></p>
                      </div>
                    </div>
                  </router-link>

                </AppParallaxeElem>
              </div>
            </template>
          </div>
        </div>
    </div>

    <!-- Mobile grid container -->

    <div v-else-if="isMobile && content" class="home__grid container">
      <div class="home__grid__products-text vertical-text">new products</div>
      <div class="home__grid__editorial-text vertical-text">editorial</div>
      <div class="home__grid__col" v-if="mobileColumns[0].length > 0">
        <div v-for="(item, index) in mobileColumns[0]" :key="index" class="home__grid__elem">
          <AppProductCard v-if="item.item.post_type === 'products'" :content="item.item"/>
          <template v-else>
            <AppLazyImg :alt="item.item.acf.preview_image.alt" :url="item.item.acf.preview_image.sizes.medium" :width="item.item.acf.preview_image.sizes['medium-width']" :height="item.item.acf.preview_image.sizes['medium-height']" :classes="['home__grid__elem__img']" />
            <div class="home__grid__elem__overlay">
              <div class="home__grid__elem__inner">
                <p class="home__grid__elem__title" v-html="item.item.acf.displayed_title"></p>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="home__grid__col" v-if="mobileColumns[1].length > 0">
        <div v-for="(item, index) in mobileColumns[1]" :key="index" class="home__grid__elem">
          <AppProductCard v-if="item.item.post_type === 'products'" :content="item.item"/>
          <template v-else>
            <AppLazyImg :alt="item.item.acf.preview_image.alt" :url="item.item.acf.preview_image.sizes.medium" :width="item.item.acf.preview_image.sizes['medium-width']" :height="item.item.acf.preview_image.sizes['medium-height']" :classes="['home__grid__elem__img']" />
            <div class="home__grid__elem__overlay">
              <div class="home__grid__elem__inner">
                <p class="home__grid__elem__title" v-html="item.item.acf.displayed_title"></p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>


    <div v-if="loadedContent" class="container">
      <section class="home__shop">
        <AppSplitLinesElem ref="splitDescription">
          <p class="home__shop__description" v-html="content.acf.shop_text" ref="splitElem"></p>
        </AppSplitLinesElem>
        <AppButton :text="content.acf.shop_button_label" link="/shop"/>
      </section>
      <div class="home__articles">
        <div class="home__articles__text vertical-text">news</div>
        <section class="home__articles__inner">
          <div class="home__articles__list">
            <AppNewsCard v-for="(item, index) in content.acf.featured_news" :key="index" class="home__news" :content="item.news" :hasDate="false"/>
          </div>
          <div class="home__articles__more">
            <AppButton text="see more" link="/articles" spaces="medium" />
          </div>
        </section>
      </div>
    </div>
    <section class="home__warriors" v-if="loadedContent">
      <AppWarriorsSlider/>
    </section>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'
  
  import AppTitle from '@/components/AppTitle.vue'
  import AppWarriorsSlider from '@/components/AppWarriorsSlider.vue'
  import AppProductCard from '@/components/AppProductCard'
  import AppNewsCard from '@/components/AppNewsCard'
  import AppButton from '@/components/AppButton'
  import AppLazyImg from '@/components/AppLazyImg.vue'
  import AppAnimatedTitle from '@/components/AppAnimatedTitle.vue'
  import AppParallaxeElem from '@/components/AppParallaxeElem.vue'
  import AppSplitLinesElem from '@/components/AppSplitLinesElem.vue'

  export default {
    name: 'Home',

    mixins: [
        Page
    ],

    components: {
      AppTitle,
      AppWarriorsSlider,
      AppProductCard,
      AppNewsCard,
      AppButton,
      AppLazyImg,
      AppAnimatedTitle,
      AppParallaxeElem,
      AppSplitLinesElem
    },

    computed: {
      mobileColumns()
      {
        const arr1 = []
        const arr2 = []

        for (let i = 0; i < this.columnItems.length; i++)
        {
          if ((i + 2) % 2 === 0) 
          {
              arr1.push(this.columnItems[i])
          }
          else
          {
              arr2.push(this.columnItems[i])
          }
        }

        return [arr1, arr2]
      }
    },

    data() {
      return {
        columnItems: []
      }
    },

    created()
    {
      const endpoint = '/wp-json/acf/v3/pages/8'


      this.loadDatas(endpoint, (res) => {
        this.content = res
        this.loadRelatedContent()
      })
    },

    destroyed()
    {
      
    },

    methods:
    {
      loadRelatedContent()
      {
        const endpoints = []

        // Grid column items
        for(let i = 0; i < this.content.acf.first_column_items.length; i++)
        {
          const endpoint = {
            // parent: 'first_column_items',
            path: ['first_column_items', i, 'item'],
            url: `/wp-json/acf/v3/products/${this.content.acf.first_column_items[i].item.ID}`
          }
          endpoints.push(endpoint)
        }

        for(let i = 0; i < this.content.acf.second_column_items.length; i++)
        {
          const endpoint = {
            // parent: 'second_column_items',
            path: ['second_column_items', i, 'item'],
            url: `/wp-json/acf/v3/products/${this.content.acf.second_column_items[i].item.ID}`
          }
          endpoints.push(endpoint)
        }

        for(let i = 0; i < this.content.acf.third_column_items.length; i++)
        {
          const endpoint = {
            // parent: 'third_column_items',
            path: ['third_column_items', i, 'item'],
            url: `/wp-json/acf/v3/products/${this.content.acf.third_column_items[i].item.ID}`
          }
          endpoints.push(endpoint)
        }

        // Featured news
        for(let i = 0; i < this.content.acf.featured_news.length; i++)
        {
          const endpoint = {
            // parent: 'news',
            path: ['featured_news', i, 'news'],
            url: `/wp-json/acf/v3/news/${this.content.acf.featured_news[i].news.ID}`
          }

          endpoints.push(endpoint)
        }

        // Load all
        this.fetchMultipleUrls(endpoints, () => {
          this.onLoadedDatas()

          this.columnItems = this.populateColumnItems()

          this.$nextTick(() => {
            this.$refs.splitDescription.initSplitLines(this.$refs.splitElem)
          })
        })
      },

      populateColumnItems()
      {
        return [...this.content.acf.first_column_items, ...this.content.acf.second_column_items, ...this.content.acf.third_column_items]
      },

      onClickHomeTitle()
      {
        this.$el.style.zIndex = 99
        this.$refs.animatedTitle.setActive()
      },
    }
  }
</script>


<style lang="stylus">
  .home__title
    // cursor pointer
    z-index 2
    position relative
    // padding-top 28vh
    // transform translateY(6vh)
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    @media(max-width 768px)
      // padding-top $space-y-mobile
      // transform translateY(0)
      padding-left $space-x-mobile

    &.not-loaded
      transform translate3d(0, 60px, 0)
      transition transform 0s $ease-in-out-circ
  
  .home__grid
    position relative
    // padding-top 40px
    padding-bottom 140px
    interpolate('padding-bottom', 1600px, 2560px, 265px, 420px);

    @media(max-width 1600px)
      interpolate('padding-bottom', 768px, 1600px, 150px, 265px);

    @media(max-width: 768px)
      display flex
      justify-content space-between
      margin-left calc(100% / 16)
      padding-top 25px

  .home__grid__products-text.vertical-text, .home__grid__editorial-text.vertical-text
    position absolute
    top 0
    left 0
    text-transform uppercase
    // font-size 14px
    

    @media(max-width: 768px)
      display none
      transform translateX(-50%) rotate(180deg)

  .home__grid__products-text.vertical-text
    // top 340px
    interpolate('padding-bottom', 768px, 2560px, 80px, 380px);

    @media(max-width: 768px)
      top 170px

  .home__grid__editorial-text.vertical-text
    bottom 300px // 140 + padding-bottom

    @media(max-width: 768px)
      bottom 500px

  .home__grid__cols
    width calc(100% / 36 * 22)
    max-width 1480px
    margin 0 auto
    position relative
    display flex
    flex-direction row
    justify-content center
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0.025s

    &.not-loaded
      transform translate3d(0, 60px, 0)
      transition transform 0s $ease-in-out-circ

    @media(max-width: 768px)
      transform translateY(0)

  .home__grid__col
    width calc(100% / 22 * 6)
    margin-right calc(100% / 22 * 2)

    @media(max-width: 768px)
      width calc(100% / 15 * 7)
      margin-right 0
      margin-left 0

    &:first-child
      transform translateY(12%)

    &:nth-child(3)
      transform translateY(8%)

      @media(max-width 768px)
        transform translateY(0)

    &:nth-child(4)
      transform translateY(-90px)

      @media(max-width: 768px)
        transform translateY(50px)

    &:last-child
      margin-right 0
  
  .home__grid__elem
    width 100%
    // margin-bottom 40px
    interpolate('margin-bottom', 768px, 2560px, 20px, 70px);

    @media(max-width: 768px)
      margin-bottom 20px

  .home__grid__elem__img
    width 100%
    display block

  .home__grid__elem__container
    position relative
    display block
    overflow hidden

    &:hover
      .home__grid__elem__overlay
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ

      .home__grid__elem__inner
        visibility visible
        transform translateY(0)
        transition transform 0.8s $ease-out-circ

  .home__grid__elem__overlay
    position absolute 
    top 0
    left 0
    width 100%
    height 100%
    background $white
    overflow hidden
    visibility hidden
    transform translateY(100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s

  .home__grid__elem__inner
    width 100%
    height 100%
    display flex
    align-items center
    justify-content center

    visibility hidden
    transform translateY(-100%)
    transition transform 0.4s $ease-out-circ, visibility 0.4s

  .home__grid__elem__title
    padding 0px 30px
    text-align center
    text-transform uppercase
    interpolate('font-size', 1600px, 2560px, 25px, 35px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 15px, 25px);

  .home__shop
    margin 0 calc(100% / 32 * 5) 100px calc(100% / 32 * 5)
    interpolate('margin-bottom', 768px, 2560px, 60px, 200px);

    @media(max-width: 768px)
      margin 0 0 40px calc(100% / 32 * 2)

  .home__shop__description
    margin-bottom 40px
    text-transform uppercase
    font-size 42px
    line-height 0.9
    interpolate('margin-bottom', 768px, 2560px, 30px, 80px)
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    @media(max-width: 768px)
      font-size 25px

  .home__news
    width calc(100% / 26 * 5)
    margin-right calc(100% / 26 * 2)

    @media(max-width: 768px)
      width 100%
      margin-right 0
      margin-bottom 40px

    &:last-child
      margin-right 0

  .home__news__image
    position relative
    width 100%

    &:before
      content ''
      display block
      padding-top 100%
  
  .home__news__image__elem
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    object-fit cover

  .home__news__title
    width 60%
    margin-top 35px
    text-transform uppercase
    font-size 18px
    line-height 1.1

  .home__articles
    position relative

    @media(max-width 768px)
      border-top 1px solid $black

  .home__articles__inner
    margin 0 calc(100% / 32 * 3) 110px calc(100% / 32 * 3)
    padding-top 110px
    interpolate('padding-top', 1600px, 2560px, 170px, 240px);
    // interpolate('margin-bottom', 1600px, 2560px, 170px, 240px);
    border-top 1px solid $black

    @media(max-width 1600px)
      interpolate('padding-top', 768px, 1600px, 70px, 170px);
      //interpolate('margin-bottom', 768px, 1600px, 70px, 170px);

    @media(max-width 768px)
      margin 0 0 110px 0
      padding-left calc(100% / 16)
      width calc(100% / 16 * 12)
      border none
    
  .home__articles__list
    display flex
    flex-wrap nowrap

    @media(max-width 768px)
      flex-direction column

  .home__articles__more
    margin-top 70px
    text-align right

    @media(max-width: 768px)
      margin-top 0
      text-align left

  .home__articles__text.vertical-text
    position absolute
    top 200px
    left 0
    // font-size 15px
    text-transform uppercase

    @media(max-width 768px)
      transform translateX(-50%) rotate(180deg)
  
</style>
